import { call, put, takeLatest } from 'redux-saga/effects'
import { USER_FORGOT_PASSWORD_REQUEST } from './constants';
import { forgetPassSuccess, forgetPassFailure } from "./actions";
import remote from '../../../../services/remote'
import SentryManager from "../../../../monitoring/Sentry";

function* forgetPassword (action) {
    try {
        const response = yield call(remote, {
            route: '/entrance/send-password-recovery-email',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(forgetPassSuccess(response.data));
        } else {
            yield put(forgetPassFailure(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

export default function* watchForgetPasswordUserSaga() {
    yield takeLatest(USER_FORGOT_PASSWORD_REQUEST , forgetPassword);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ForgetPassword/saga.js